import React from 'react';
import { FiCheck, FiGlobe } from 'react-icons/fi';
import { Popover } from '../ui';
import { t } from './index';
import { useLang } from './I18nProvider';

/** globe button with the three languages; `compact` hides the label (topbar), otherwise shows the current one */
export default function LanguageMenu({ compact = true, up = false, align = 'right' }) {
  const { lang, setLang, langs } = useLang();
  const cur = langs.find((l) => l.code === lang) || langs[0];
  return (
    <Popover up={up} align={align} trigger={
      <button className={compact ? 'icon-btn lang-btn' : 'btn lang-btn-full'} aria-label={t('Language')} title={t('Language')}>
        <FiGlobe />{!compact && <span style={{ marginInlineStart: 6 }}>{cur.native}</span>}
      </button>
    }>
      {(close) => (
        <div role="menu" aria-label={t('Language')}>
          {langs.map((l) => (
            <button key={l.code} role="menuitemradio" aria-checked={l.code === lang} className="menu-item" lang={l.code} dir={l.dir} onClick={() => { close(); if (l.code !== lang) setLang(l.code); }}>
              <span style={{ flex: 1, textAlign: 'start' }}>{l.native}</span>{l.code === lang && <FiCheck />}
            </button>
          ))}
        </div>
      )}
    </Popover>
  );
}
